import ReactDOM from "react-dom/client";
import React from "react";
import App from "./App.jsx";
import "./index.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Provider } from "react-redux";
import store from "./store/store.js";
import * as Sentry from "@sentry/react";
const sentrySecret = import.meta.env.VITE_SENTRY_SECRET;

const envMode = import.meta.env.MODE;
const hostname = window.location.hostname;

// console.log("envMode---------", envMode);
// console.log("hostname---------", hostname);

let sentryEnv = null;

if (hostname === "staging.react.kuick.com") {
  sentryEnv = "staging";
} else if (hostname === "prod.react.kuick.com") {
  sentryEnv = "production";
}
// else if (hostname === "localhost") {
//   sentryEnv = "development";
// }

// if (sentryEnv) {
//   Sentry.init({
//     dsn: sentrySecret,
//     integrations: [
//       Sentry.browserTracingIntegration(),
//       Sentry.replayIntegration(),
//     ],
//     tracesSampleRate: 1.0,
//     tracePropagationTargets: [
//       "https://staging.react.kuick.com/",
//       "https://prod.react.kuick.com/",
//     ],
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//     environment: sentryEnv,
//     release: `kuick-frontend@${import.meta.env.VITE_APP_VERSION || "0.0.1"}`, // optional versioning
//   });
// }

// React root setup
let root;

function renderApp() {
  const container = document.getElementById("root");

  if (!root) {
    root = ReactDOM.createRoot(container);
  }

  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}

renderApp();
